import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IllustrationStreak = function IllustrationStreak(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({}, newProps), {}, {
    className: classNames('sol-illustration', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "illustration.streak"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    d: "M71.5 11.1509C73.433 11.1509 75 9.58388 75 7.65088C75 5.71788 73.433 4.15088 71.5 4.15088C69.567 4.15088 68 5.71788 68 7.65088C68 9.58388 69.567 11.1509 71.5 11.1509Z",
    fill: "#40AF0C"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_2",
    d: "M40 72.1509C57.6731 72.1509 72 57.824 72 40.1509C72 22.4778 57.6731 8.15088 40 8.15088C22.3269 8.15088 8 22.4778 8 40.1509C8 57.824 22.3269 72.1509 40 72.1509Z",
    fill: "#40AF0C"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_3",
    d: "M12 67.1509C12 69.36 10.2091 71.1509 8 71.1509C5.79086 71.1509 4 69.36 4 67.1509C4 64.9417 5.79086 63.1509 8 63.1509C10.2091 63.1509 12 64.9417 12 67.1509Z",
    fill: "#40AF0C"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_4",
    d: "M70.5 22.1509C71.8807 22.1509 73 21.0316 73 19.6509C73 18.2702 71.8807 17.1509 70.5 17.1509C69.1193 17.1509 68 18.2702 68 19.6509C68 21.0316 69.1193 22.1509 70.5 22.1509Z",
    fill: "#40AF0C"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_5",
    d: "M7 47.6509C7 49.0316 5.88071 50.1509 4.5 50.1509C3.11929 50.1509 2 49.0316 2 47.6509C2 46.2702 3.11929 45.1509 4.5 45.1509C5.88071 45.1509 7 46.2702 7 47.6509Z",
    fill: "#40AF0C"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_6",
    d: "M17.5 74.1509C18.8807 74.1509 20 73.0316 20 71.6509C20 70.2702 18.8807 69.1509 17.5 69.1509C16.1193 69.1509 15 70.2702 15 71.6509C15 73.0316 16.1193 74.1509 17.5 74.1509Z",
    fill: "#40AF0C"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_7",
    d: "M27.7882 36.6765C26.4436 37.909 27.3156 40.1508 29.1396 40.1508H37.6344L33.6674 55.6351C33.1737 57.562 35.4899 58.9499 36.9562 57.6058L52.2079 43.6251C53.5525 42.3926 52.6805 40.1508 50.8565 40.1508H42.3617L46.3287 24.6665C46.8224 22.7396 44.5062 21.3517 43.0399 22.6958L27.7882 36.6765Z",
    fill: "white"
  })));
};

export { IllustrationStreak };
